var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success"},[_c('img',{attrs:{"src":require("./icon.svg"),"alt":"mail"}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('thanks_well_reply_within_24_hours')))]),_c('app-button',{attrs:{"size":"md","theme":"secondary"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('ok')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }